import {
  WebsocketMessageType,
  INonFlyingAssignment,
  IWebsocketUpdateNFAEvent,
  IUser,
} from "@vmosolutions/oc-interfaces";
import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { IRootState } from "../../reducers/CombinedReducers";
import { AnyAction } from "redux";
import { ICrewEvent, ICrewNonFlyingAssignmentMap, newCrewNFA } from "../../reducers/CrewScheduleReducer";
import { Type } from "./CrewSchedule.Actions";

const findNFA = (id: string) => (nfa: INonFlyingAssignment) => nfa._id === id;

/**
 * use a websocket action with Thunk to update the redux store
 * for display pairings
 * @param updatedEvent -
 * @param actionType -
 */
export const webSocketUpdateNFAEvent = (
  updatedEvent: IWebsocketUpdateNFAEvent,
  actionType: WebsocketMessageType
): ThunkAction<void, IRootState, object, AnyAction> => {
  return (dispatch: ThunkDispatch<IRootState, object, AnyAction>, getState: () => IRootState): void => {
    // no update, nothing to do
    if (!updatedEvent) return;

    const { oldEvent, newEvent } = updatedEvent;

    const crewNFAMap: ICrewNonFlyingAssignmentMap = { ...getState().crewSchedule.crewNonFlyingAssignments };
    const selectedCrewScheduleEvents: ICrewEvent[] = getState().crewSchedule.selectedCrewEvents;
    //was the update NFA selected?
    if (
      !!selectedCrewScheduleEvents?.length &&
      !!newEvent &&
      selectedCrewScheduleEvents.some((e) => e.event._id === newEvent._id)
    ) {
      //if the nfa that was updated is selected, update the selected events
      const updatedSelectedEvents = selectedCrewScheduleEvents?.map((e) => {
        if (e.event._id === newEvent._id) {
          e.event = newEvent;
          return e;
        }
        return e;
      });
      dispatch({
        type: Type.SET_SELECTED_CREW_EVENTS,
        newEvents: updatedSelectedEvents,
        update: true,
      });
    }

    const lastModified = Date.now();
    const crew: IUser[] = oldEvent ? [...oldEvent.crew] : [];
    newEvent?.crew.forEach((user: IUser) => {
      if (crew.findIndex((pos: IUser) => pos._id === user._id) < 0) {
        crew.push(user);
      }
    });

    crew.forEach((crewMember: IUser) => {
      if (!crewNFAMap[crewMember._id]) {
        crewNFAMap[crewMember._id] = newCrewNFA(lastModified);
      }
      const crewNFAs = crewNFAMap[crewMember._id];
      crewNFAs.lastModified = lastModified;
      const nfas = [...crewNFAs.nonFlyingAssignments];
      const oldNFAIndex = oldEvent ? nfas.findIndex(findNFA(oldEvent._id)) : -1;

      if (oldNFAIndex >= 0) {
        const crewInNewPairingIndex = newEvent?.crew.findIndex((newEventUser: IUser) => {
          return newEventUser._id === crewMember._id;
        });
        if (newEvent && crewInNewPairingIndex >= 0) {
          nfas[oldNFAIndex] = newEvent;
        } else {
          nfas.splice(oldNFAIndex, 1);
        }
      } else {
        if (newEvent) {
          nfas.push(newEvent);
        }
      }
      nfas.sort((a: INonFlyingAssignment, b: INonFlyingAssignment) => a.start?.valueOf() - b.start?.valueOf());
      crewNFAs.nonFlyingAssignments = nfas;
    });

    dispatch({
      type: Type.UPDATE_CREW_NFAS,
      crewNFAMap,
    });
  };
};
